import Modal from '@web-ui-kit/modal'

import * as Sc from '../Modals.styles'

import { useGlobalModalContext } from 'contexts/GlobalModalContext'
import { isMobile } from 'utils/rebrandingUtils'
import { useWindowDimensions } from 'hooks'
import i18n from 'i18n'

const ModalConfirmDeleteLink = () => {
  const { store } = useGlobalModalContext()
  const { modalProps } = store || {}
  const { body, onCancel, onCancelText, onConfirm, onConfirmText } = modalProps || {}

  const { width: windowWidth } = useWindowDimensions()

  const isFullScreenModal = isMobile(windowWidth)

  return (
    <Modal
      buttons={{
        contained: {
          label: onConfirmText,
          onClick: onConfirm,
        },
        outlined: {
          label: onCancelText,
          onClick: onCancel,
        },
      }}
      handleCloseModal={onCancel}
      isSmall={isFullScreenModal}
      topNav={{
        enableCloseIcon: isFullScreenModal,
        title: isFullScreenModal ? i18n.t('Eliminar enlace') : '',
      }}
    >
      <div>
        <Sc.ModalContentTitle variant='body'>{body.question}</Sc.ModalContentTitle>
        <Sc.ModalContentTitle variant='body'>{body.warning}</Sc.ModalContentTitle>
      </div>
    </Modal>
  )
}

export default ModalConfirmDeleteLink
